/**
 * Refine-DataProvider fuer die MAESTRO-Worker-API.
 *
 * Ruft ausschliesslich die Worker-Endpunkte (/api/*) auf - KEIN direkter DB-Zugriff vom Browser.
 * Der Tenant wird serverseitig (Subdomain bzw. Dev-Header) bestimmt, nicht hier mitgegeben.
 */
import type { DataProvider } from "@refinedev/core";
import { apiFetch, toApiError } from "../lib/api";

const API_URL = import.meta.env.VITE_API_URL ?? "";

export const dataProvider: DataProvider = {
  getApiUrl: () => API_URL,

  getList: async ({ resource }) => {
    const res = await apiFetch(`/api/${resource}`);
    if (!res.ok) throw await toApiError(res);
    const json = (await res.json()) as { data: unknown[]; total?: number };
    return { data: json.data as never, total: json.total ?? json.data.length };
  },

  getOne: async ({ resource, id }) => {
    // Spike: Einzel-Endpunkt noch nicht im Worker -> aus der (mandantengefilterten) Liste holen.
    const res = await apiFetch(`/api/${resource}`);
    if (!res.ok) throw await toApiError(res);
    const json = (await res.json()) as { data: Array<{ id: string | number }> };
    const found = json.data.find((r) => String(r.id) === String(id));
    return { data: found as never };
  },

  create: async ({ resource, variables }) => {
    const res = await apiFetch(`/api/${resource}`, {
      method: "POST",
      body: JSON.stringify(variables),
    });
    if (!res.ok) throw await toApiError(res);
    const json = (await res.json()) as { data: unknown };
    return { data: json.data as never };
  },

  update: async () => {
    throw new Error("update: im Spike-Scaffold nicht implementiert.");
  },

  deleteOne: async () => {
    throw new Error("deleteOne: im Spike-Scaffold nicht implementiert.");
  },
};
